import { Download } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";

import Grid from '@mui/material/Grid2';
import { useState } from "react";

import Search from "../../../components/Search";
import {
  create,
  update,
  useList,
  deleteUnitMeasurement,
  exportAll,
  isInUse,
} from "../../../services/unitMeasurement";
import UnitMeasurementForm from "./components/UnitMeasurementForm";
import DataTable from "./components/DataTable";
import { hasClaim } from "../../../storage/userClaims";
import useForms from "../../utils/forms/useForm.hook";

interface IParams {
  page: number;
  keyword: string;
  sort: string;
  limit: number;
  uri: string;
  param: string;
}

export const mapData = (data: any) => {
  if (typeof data.SIGLA !== 'string') {
    throw new Error('SIGLA must be a string');
  }

  return {
    ID_UM: data.ID_UM,
    SIGLA: data.SIGLA.toUpperCase(),
    DESCRICAO: data.DESCRICAO,
    ATIVO: data.ATIVO,
  }
};

export default function UnitMeasurements() {
  const [params, setParams] = useState<IParams>({
    page: 1,
    limit: 10,
  } as IParams);

  const { data, meta, isLoading } = useList(params);


  const {
    selectedData,
    controlEdit,
    isSaving,
    modalOpen,
    setModalOpen,
    openDeleteModal,
    setOpenDeleteModal,
    errors,
    readOnly,
    paginationModel,
    setPaginationModel,

    handleRequest,
    handleEditData,
    handleDeleteDataConfirmation,
    handleDeleteData,
    handleFormSubmit,
    exportData,
    handleCancelEditData,
    onViewData,
    onNew,
  } = useForms({
    actions: {
      create,
      deleteData: deleteUnitMeasurement,
      exportAll,
      update,
      isInUse
    },
    configs:{
      findKey: "ID_UM",
      entityName: "Unit of Measurement",
    },

    data,
    params,
    setParams
  });

  return (
    <Grid marginTop={4}>
      <Grid container spacing={1} direction="column">
        <Grid item xs={10}>
          <Typography variant="h5">Unit Of Measurement</Typography>
        </Grid>
        {!modalOpen ? (
          <Grid item xs={2} marginTop={1}>
            <Button
              sx={{
                display: hasClaim("Unit Of Measurement - Maintenance")
                  ? "block"
                  : "none",
              }}
              variant="contained"
              onClick={() => onNew()}
            >
              New
            </Button>
          </Grid>
        ) : null}
      </Grid>
      {modalOpen ? (
        <Grid container alignItems="center">
          <UnitMeasurementForm
            onSubmit={(data) => handleFormSubmit(mapData(data))}
            unitMeasurement={selectedData}
            onCancel={handleCancelEditData}
            isLoading={isSaving}
            errors={errors}
            controlEdit={controlEdit}
            readOnly={readOnly}
          />
        </Grid>
      ) : null}
      <Search onChange={handleRequest} />
      <Grid container marginTop={4} justifyContent="flex-end">
        <Button
          variant="text"
          onClick={exportData}
          startIcon={<Download />}
        >
          Export XLSX
        </Button>
      </Grid>
      <Grid>
        <DataTable
          loading={isLoading}
          data={data}
          onDeleteUnit={handleDeleteDataConfirmation}
          onEditUnit={(data: string, data2) => {
            handleEditData(+data, mapData)
          }}
          onViewUnit={(data: string) => onViewData(+data, mapData)}
          rowCount={meta?.total || 0}
          onPaginationModelChange={(e: any) => {
            setPaginationModel(e);
            handleRequest({ page: e.page + 1, limit: e.pageSize });
          }}
          paginationModel={paginationModel}
          pagination
          initialState={{
            pagination: { paginationModel: { pageSize: params.limit } },
          }}
          pageSizeOptions={[10, 25, 50, 100]}
          paginationMode="server"
        />
      </Grid>
      <Dialog
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Delete Unit of Measurement
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure that you want to delete this Unit of Measurement?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteModal(false)}>Cancel</Button>
          <Button onClick={handleDeleteData}>Confirm</Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}
